import styles from "./History.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useMemo } from "react";
import { useSessionStorage } from "react-use";
import { ProspectInfoExpander } from "../../ProspectInfoExpander/ProspectInfoExpander";
import { useTranslation } from "react-i18next";
import { InfoListItem } from "../../InfoListItem/InfoListItem";
import processSteps from "../../processSteps";

export function History({ contact }) {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useSessionStorage("prospect-history-open", false);

  const steps = useMemo(() => {
    // Sort in chronological order for tallying steps and reverse before returning.
    const source = contact.history.sort((a, b) => {
      if (a.createdOn < b.createdOn) {
        return -1;
      } else if (a.createdOn > b.createdOn) {
        return 1;
      } else {
        return 0;
      }
    });

    const records = [];
    const counts = {};

    for (const rec of source) {
      counts[rec.step] = (counts[rec.step] || 0) + 1;
      // const step = processSteps.find((s) => s.name === rec.step);

      // console.log({ step, rec });

      records.push({
        title: rec.step,
        date: rec.createdOn,
        content: rec.details && rec.details.trim !== "" ? rec.details : null,
      });
    }

    return records.reverse();
  }, [contact]);

  return (
    <ProspectInfoExpander
      title={t("labels.prospectHistory")}
      isOpen={isOpen}
      onToggle={setIsOpen}
    >
      {steps.length === 0 ? (
        <span className={styles.emptyLabel}>
          {t("labels.prospectHistoryEmptyLabel")}
        </span>
      ) : (
        steps.map((step, i) => <InfoListItem key={i} {...step} />)
      )}
    </ProspectInfoExpander>
  );
}

History.propTypes = {};
